<template>
  <header class="wrapper">
    <div
      class="header container"
      :class="{ 'header_search-expanded': isSearchExpanded }"
    >
      <router-link class="logo" :to="homeLink">
        <span class="logo__text">
          App
        </span>
        <img
          class="logo__img"
          :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)"
        />
        <span class="logo__text">
          Store
        </span>
      </router-link>

      <theme-switch class="header__theme-switch" />

      <links class="header__links" />

      <device class="header__device" />
    </div>
    <navigation />
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Device from './Device';
import Search from './Search';
import Links from './Links';
import Navigation from './Navigation';
import ThemeSwitch from './ThemeSwitch.vue';

export default {
  components: {
    Device, Search, Links, Navigation, ThemeSwitch,
  },
  computed: {
    ...mapState(['theme']),
    ...mapGetters(['currentDeviceOS']),
    isSearchExpanded() {
      return this.$store.getters.isSearchExpanded;
    },
    homeLink() {
      if (!this.currentDeviceOS) {
        return '/';
      }

      return `/?compatibility=${this.currentDeviceOS}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.wrapper {
  position: relative;
}

.header {
  padding: 25px 0;
  display: flex;
  align-items: center;

  @include notebook {
    padding: 10px 0;
  }

  &_search-expanded {
    @include notebook {
      .header__search {
        margin-left: 10px;
      }

      .header__device,
      .header__theme-switch {
        display: none;
      }
    }
  }

  &__search {
    margin: 0 15px 0 20px;

    @include notebook {
      order: 4;
      margin-left: auto;
      margin-right: 6px;
    }
  }

  &__theme-switch {
    margin-left: auto;
    margin-right: 20px;

    @include notebook {
      order: 3;
      margin-right: 15px;
    }
  }

  &__links {
    @include notebook {
      order: 5;
      margin-right: 10px;
    }
  }

  &__device {
    @include notebook {
      order: 2;
      margin-left: 14px;
      margin-right: 14px;
      display: block;
      min-width: 0;
      position: relative;
      height: 41px;
    }
  }
}

.logo {
  display: flex;
  gap: 5px;
  align-items: center;
  color: var(--text-primary);
  font-size: 25px;
  letter-spacing: -1px;
  flex-shrink: 0;

  &__text {
    position: relative;
    top: -2px;

    @include notebook {
      top: 0;

      &:first-child {
        display: none;
      }
    }
  }

  @include notebook {
    order: 1;
    // max-width: 49px;
    // height: 41px;
    // flex: 0 0 49px;
  }

  &__img {
    max-width: 100%;
    height: 37px;

    &_mobile {
      display: none;

      @include notebook {
        display: block;
      }
    }

    &_desktop {
      @include notebook {
        display: none;
      }
    }
  }
}
</style>
